export const config = {
    //identityPoolId: "us-east-2:6cd3893b-aeba-4548-bc0f-b0306609534b",
    region: 'us-east-2', 
    userPoolId: 'us-east-2_6tu1b2ias',
    userPoolWebClientId: '78j7cfgj9bb7a7ngt5th4bq6hg',
}